import React, { useEffect } from "react";
import LogoImagen from "./assets/logo/logo-imagen";
import LogoTexto from "./assets/logo/logo-texto";
import { ReactComponent as LogoCofolp } from './assets/logo/logo_2.svg';
import { ReactComponent as CheckIcon } from "./assets/img/check_icon.svg";
import { ReactComponent as CloseIcon } from "./assets/img/close_icon.svg";
import "./portal.scss"

// Declaración global para PureCounter en window
declare global {
  interface Window {
    PureCounter?: any;
  }
}

export const PortalHome: React.FC = () => {

  const [tabIndex, setTabIndex] = React.useState<string>('home');

  // Datos de ejemplo de profesionales
  const profesionalesData = [
    {
      nombre: 'Walter White',
      consultorio: 'Av. Spinetto 670, Santa Rosa',
      localidad: 'Santa Rosa',
      telefono: '2954-123456',
      matricula: '1234',
      cuit: '20-12345678-9',
      especialidades: ['Fonoaudiología', 'Audiología'],
      atiendeObraSocial: true,
      redes: {
        twitter: 'https://twitter.com',
        facebook: 'https://facebook.com',
        instagram: 'https://instagram.com',
        linkedin: 'https://linkedin.com',
      },
    },
    {
      nombre: 'Sarah Jhonson',
      consultorio: 'Belgrano 123, General Pico',
      localidad: 'General Pico',
      telefono: '2954-654321',
      matricula: '5678',
      cuit: '27-87654321-0',
      especialidades: ['Voz', 'Lenguaje'],
      atiendeObraSocial: false,
      redes: {
        // twitter: 'https://twitter.com',
        facebook: 'https://facebook.com',
        instagram: 'https://instagram.com',
        // linkedin: 'https://linkedin.com',
      },
    },
    {
      nombre: 'William Anderson',
      consultorio: 'Rivadavia 456, Santa Rosa',
      localidad: 'Santa Rosa',
      telefono: '2954-789012',
      matricula: '9101',
      cuit: '23-11223344-5',
      especialidades: ['Odontoesmatología'],
      atiendeObraSocial: true,
      redes: {
        twitter: 'https://twitter.com',
        facebook: 'https://facebook.com',
        instagram: 'https://instagram.com',
        linkedin: 'https://linkedin.com',
      },
    },
    {
      nombre: 'Amanda Jepson',
      consultorio: 'San Martín 789, Toay',
      localidad: 'Toay',
      telefono: '2954-345678',
      matricula: '1121',
      cuit: '27-55667788-1',
      especialidades: ['Rehabilitación', 'Audiología'],
      atiendeObraSocial: true,
      redes: {
        twitter: 'https://twitter.com',
        facebook: 'https://facebook.com',
        instagram: 'https://instagram.com',
        linkedin: 'https://linkedin.com',
      },
    },
    // Nuevos profesionales de ejemplo
    {
      nombre: 'Lucía Fernández',
      consultorio: 'Av. Luro 1500, Santa Rosa',
      localidad: 'Santa Rosa',
      telefono: '2954-111222',
      matricula: '2233',
      cuit: '27-33445566-2',
      especialidades: ['Lenguaje', 'Fonoaudiología'],
      atiendeObraSocial: true,
      redes: {
        twitter: '',
        facebook: 'https://facebook.com/luciaf',
        instagram: 'https://instagram.com/luciaf',
        linkedin: '',
      },
    },
    {
      nombre: 'Martín Gómez',
      consultorio: 'Calle 9 N° 456, General Pico',
      localidad: 'General Pico',
      telefono: '2954-333444',
      matricula: '3344',
      cuit: '20-99887766-3',
      especialidades: ['Audiología'],
      atiendeObraSocial: false,
      redes: {
        twitter: 'https://twitter.com/mgomez',
        facebook: '',
        instagram: '',
        linkedin: 'https://linkedin.com/in/mgomez',
      },
    },
    {
      nombre: 'Paula Sosa',
      consultorio: 'Av. Perón 234, Toay',
      localidad: 'Toay',
      telefono: '2954-555666',
      matricula: '4455',
      cuit: '23-44556677-8',
      especialidades: ['Voz', 'Rehabilitación'],
      atiendeObraSocial: true,
      redes: {
        twitter: '',
        facebook: '',
        instagram: 'https://instagram.com/paulasosa',
        linkedin: '',
      },
    },
    {
      nombre: 'Federico Ruiz',
      consultorio: 'Mitre 800, Santa Rosa',
      localidad: 'Santa Rosa',
      telefono: '2954-777888',
      matricula: '5566',
      cuit: '20-22334455-6',
      especialidades: ['Odontoesmatología', 'Lenguaje'],
      atiendeObraSocial: false,
      redes: {
        twitter: 'https://twitter.com/federicoruiz',
        facebook: '',
        instagram: '',
        linkedin: '',
      },
    },
    {
      nombre: 'María López',
      consultorio: 'Calle 25 N° 100, General Pico',
      localidad: 'General Pico',
      telefono: '2954-999000',
      matricula: '6677',
      cuit: '27-77889900-1',
      especialidades: ['Fonoaudiología'],
      atiendeObraSocial: true,
      redes: {
        twitter: '',
        facebook: 'https://facebook.com/marialopez',
        instagram: '',
        linkedin: '',
      },
    },
  ];

  // Estado de filtros
  const [filtroNombre, setFiltroNombre] = React.useState('');
  const [filtroLocalidad, setFiltroLocalidad] = React.useState('');
  const [filtroObraSocial, setFiltroObraSocial] = React.useState('');
  const [filtroEspecialidad, setFiltroEspecialidad] = React.useState('');

  // Obtener opciones únicas de localidad y especialidad
  const localidades = Array.from(new Set(profesionalesData.map(p => p.localidad)));
  const especialidades = Array.from(new Set(profesionalesData.flatMap(p => p.especialidades)));

  // Filtrado de profesionales
  const profesionalesFiltrados = profesionalesData.filter(p => {
    const matchNombre = p.nombre.toLowerCase().includes(filtroNombre.toLowerCase());
    const matchLocalidad = !filtroLocalidad || p.localidad === filtroLocalidad;
    const matchObraSocial =
      !filtroObraSocial ||
      (filtroObraSocial === 'si' && p.atiendeObraSocial) ||
      (filtroObraSocial === 'no' && !p.atiendeObraSocial);
    const matchEspecialidad =
      !filtroEspecialidad || p.especialidades.includes(filtroEspecialidad);
    return matchNombre && matchLocalidad && matchObraSocial && matchEspecialidad;
  });

  useEffect(() => {
  if (tabIndex === 'institucional' && window.PureCounter) {
    new window.PureCounter();
  }
}, [tabIndex]);

  useEffect(() => {
    // Cargar scripts JS solo cuando el portal está montado
    const scripts = [
      './assets/portal/vendor/bootstrap/js/bootstrap.bundle.min.js',
      './assets/portal/vendor/php-email-form/validate.js',
      './assets/portal/vendor/aos/aos.js',
      './assets/portal/vendor/glightbox/js/glightbox.min.js',
      './assets/portal/vendor/purecounter/purecounter_vanilla.js',
      './assets/portal/js/main.js',
    ];
    const scriptElements = scripts.map(src => {
      const script = document.createElement('script');
      script.src = src;
      script.async = true;
      document.body.appendChild(script);
      return script;
    });
    // Cargar fuentes solo para el portal
    const fontLinks = [
      { href: 'https://fonts.googleapis.com', rel: 'preconnect' },
      { href: 'https://fonts.gstatic.com', rel: 'preconnect', crossorigin: 'anonymous' },
      { href: 'https://fonts.googleapis.com/css2?family=Roboto:ital,wght@0,100;0,300;0,400;0,500;0,700;0,900;1,100;1,300;1,400;1,500;1,700;1,900&family=Poppins:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&display=swap', rel: 'stylesheet' },
    ];
    const linkElements = fontLinks.map(props => {
      const link = document.createElement('link');
      Object.entries(props).forEach(([key, value]) => link.setAttribute(key, value));
      document.head.appendChild(link);
      return link;
    });
    // Cargar estilos CSS solo para el portal
    const cssLinks = [
      '/assets/portal/vendor/bootstrap/css/bootstrap.min.css',
      '/assets/portal/vendor/bootstrap-icons/bootstrap-icons.css',
      '/assets/portal/vendor/aos/aos.css',
      '/assets/portal/vendor/fontawesome-free/css/all.min.css',
      '/assets/portal/vendor/glightbox/css/glightbox.min.css',
      '/assets/portal/vendor/swiper/swiper-bundle.min.css',
      '/assets/portal/css/main.css',
    ];
    const cssElements = cssLinks.map(href => {
      const link = document.createElement('link');
      link.rel = 'stylesheet';
      link.href = href;
      document.head.appendChild(link);
      return link;
    });
    return () => {
      scriptElements.forEach(script => {
        if (document.body.contains(script)) document.body.removeChild(script);
      });
      linkElements.forEach(link => {
        if (document.head.contains(link)) document.head.removeChild(link);
      });
      cssElements.forEach(link => {
        if (document.head.contains(link)) document.head.removeChild(link);
      });
    };
  }, []);

  return (
    <>
      {/* HEADER */}
      <header id="header" className="header sticky-top">
        <div className="topbar d-flex align-items-center">
          <div className="container d-flex justify-content-center justify-content-md-between">
            <div className="d-none d-md-flex align-items-center">
              <i className="bi me-1"></i> Colegio Profesional de Fonoaudiólogos de La Pampa
            </div>
            <div className="d-flex align-items-center">
              <i className="bi bi-phone me-1"></i> Tel. +54 2954 702284 (sede)
            </div>
          </div>
        </div>
        <div className="branding d-flex align-items-center">
          <div className="container position-relative d-flex align-items-center justify-content-end">
            <a href="index.html" className="logo d-flex align-items-center me-auto">
              <img src= "assets/img/logo-cofolp.png" alt="" />
            </a>
            <nav id="navmenu" className="navmenu">
              <ul>
                <li><a href="#" className="active" onClick={() => setTabIndex('home')}>Inicio</a></li>
                <li className="dropdown"><a  href='#' onClick={() => setTabIndex('institucional')}><span>Institucional</span> <i className="bi bi-chevron-down toggle-dropdown"></i></a>
                  <ul>
                    <li><a  href='#' onClick={() => setTabIndex('institucional')}>Quiénes somos?</a></li>
                    <li><a  href='#' onClick={() => setTabIndex('institucional')}>Comisión Directiva</a></li>
                    <li><a  href='#' onClick={() => setTabIndex('institucional')}>Tribunal de Etica y Disciplina</a></li>
                    <li><a  href='#' onClick={() => setTabIndex('institucional')}>Comisión Revisora de Cuentas</a></li>
                  </ul>
                </li>
                <li className="dropdown"><a href="#" onClick={() => setTabIndex('tramites')}><span>Trámites</span> <i className="bi bi-chevron-down toggle-dropdown"></i></a>
                  <ul>
                    <li><a href="#"  onClick={() => setTabIndex('matriculacion')}>Matriculación</a></li>
                    <li><a href="#"  onClick={() => setTabIndex('consultorio')}>Consultorio</a></li>
                    <li><a href="#"  onClick={() => setTabIndex('tramites')}>Título</a></li>
                    <li><a href="#"  onClick={() => setTabIndex('tramites')}>Baja de Matrícula</a></li>
                  </ul>
                </li>
                <li className="dropdown"><a  href='#'  onClick={() => setTabIndex('ejercicio-profesional')}><span>Ejercicio Profesional</span> <i className="bi bi-chevron-down toggle-dropdown"></i></a>
                  <ul>
                    <li><a href='#' onClick={() => setTabIndex('ejercicio-profesional')}>Honorarios Mínimos</a></li>
                    <li><a  href='#' onClick={() => setTabIndex('ejercicio-profesional')}>Código de ética</a></li>
                    <li><a href="#" onClick={() => setTabIndex('certificado-etica')}>Certificado de ética</a></li>
                    <li><a  href='#' onClick={() => setTabIndex('ejercicio-profesional')}>Consentimiento informado</a></li>
                    <li><a  href='#' onClick={() => setTabIndex('ejercicio-profesional')}>Habilitación de Consultorio</a></li>
                  </ul>
                </li>
                <li><a href="#" onClick={() => setTabIndex('profesionales')}>Profesionales</a></li>
                <li><a href="#">Obras Sociales</a></li>
                <li><a href="#" onClick={() => setTabIndex('contacto')}>Contacto</a></li>
              </ul>
              <i className="mobile-nav-toggle d-xl-none bi bi-list"></i>
            </nav>
            <a className="cta-btn" href="http://145.223.94.120/" target="_blank" rel="noopener noreferrer">AUTOGESTION</a>
          </div>
        </div>
      </header>
      
      
      {/* MAIN CONTENT */}
      <main className="main">
        {tabIndex === 'home' && (
          <>
            <section id="hero" className="hero section" style={{
              position: 'relative',
              minHeight: '340px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              background: 'rgba(20, 165, 209, 0.85)',
              overflow: 'hidden',
            }}>
              <div style={{
                width: '100%',
                height: '100%',
                display: 'flex',
                flexDirection: 'row',
                alignItems: 'center',
                justifyContent: 'space-between',
              }}>
                <img
                  src="/assets/portal/img/logo_cofolp.svg"
                  alt="Logo Cofolp"
                  style={{
                    width: '100%',
                    height: '100%',
                    maxWidth: '900px',
                    maxHeight: '340px',
                    objectFit: 'contain',
                    filter: 'brightness(0) invert(1)',
                    display: 'block',
                    paddingLeft: '20px'
                  }}
                />
                <img
                  src="/assets/portal/img/banner_1.svg"
                  alt="Banner decorativo"
                  className="banner-deco"
                  style={{
                    width: '40%',
                    height: '100%',
                    maxWidth: '900px',
                    maxHeight: '340px',
                    objectFit: 'contain',
                    display: 'block',
                    paddingRight: '20px'
                  }}
                />
              </div>
              <style>{`
                @media (max-width: 480px) {
                  .banner-deco {
                    display: none !important;
                  }
                  #hero img {
                    width: 100% !important;
                    max-width: 100% !important;
                    padding-left: 0 !important;
                  }
                }
              `}</style>
            </section>
            {/* Hero Section */}


            {/* Featured Services Section */}
            <section id="featured-services" className="featured-services section">
              <div className="container">

                <div className="row gy-4">

                  <div className="col-xl-3 col-md-6 d-flex" data-aos="fade-up" data-aos-delay="100">
                    <div className="service-item position-relative">
                      <div className="icon"><i className="fa-regular fa-building icon"></i></div>
                      <h4><a href="#institucional" className="stretched-link">Institucional</a></h4>
                      <p>Conozca más sobre nuestra institución y su historia.</p>
                    </div>
                  </div>

                  <div className="col-xl-3 col-md-6 d-flex" data-aos="fade-up" data-aos-delay="200">
                    <div className="service-item position-relative">
                      <div className="icon"><i className=" fa-regular fa-user icon"></i></div>
                      <h4><a href="#ejercicioprofesional" className="stretched-link">Ejercicio Profesional</a></h4>
                      <p>Todas dudas y consultas que tenga acerca del ejercicio de la profesión las resolverá aquí.</p>
                    </div>
                  </div>

                  <div className="col-xl-3 col-md-6 d-flex" data-aos="fade-up" data-aos-delay="300">
                    <div className="service-item position-relative">
                      <div className="icon"><i className="fa-regular fa-user-md icon"></i></div>
                      <h4><a href="#profesionales" className="stretched-link">Profesionales</a></h4>
                      <p>Conozca a nuestros profesionales.</p>
                    </div>
                  </div>

                  <div className="col-xl-3 col-md-6 d-flex" data-aos="fade-up" data-aos-delay="400">
                    <div className="service-item position-relative">
                      <div className="icon"><i className="fa-regular fa-newspaper icon"></i></div>
                      <h4><a href="#obrassociales" className="stretched-link">Obras Sociales</a></h4>
                      <p>Convenios vigentes. Formularios para alta y baja.</p>
                    </div>
                  </div>

                </div>
              </div>
            </section>
          </>
        )}

        {tabIndex === 'institucional' && (
          <>
           {/* Stats Section */}
            <section id="stats" className="stats section">
              <div className="container" data-aos="fade-up" data-aos-delay="100">

                <div className="row gy-4">

                  <div className="col-lg-3 col-md-6">
                    <div className="stats-item d-flex align-items-center w-100 h-100">
                      <i className="fas fa-user-md flex-shrink-0"></i>
                      <div>
                        <span data-purecounter-start="0" data-purecounter-end="250" data-purecounter-duration="1" className="purecounter"></span>
                        <p>Profesionales</p>
                      </div>
                    </div>
                  </div>

                  <div className="col-lg-3 col-md-6">
                    <div className="stats-item d-flex align-items-center w-100 h-100">
                      <i className="far fa-hospital flex-shrink-0"></i>
                      <div>
                        <span data-purecounter-start="0" data-purecounter-end="145" data-purecounter-duration="1" className="purecounter"></span>
                        <p>Consultorios</p>
                      </div>
                    </div>
                  </div>

                  <div className="col-lg-3 col-md-6">
                    <div className="stats-item d-flex align-items-center w-100 h-100">
                      <i className="fas fa-newspaper flex-shrink-0"></i>
                      <div>
                        <span data-purecounter-start="0" data-purecounter-end="32" data-purecounter-duration="1" className="purecounter"></span>
                        <p>Convenios Obra Social Vigentes</p>
                      </div>
                    </div>
                  </div>

                  <div className="col-lg-3 col-md-6">
                    <div className="stats-item d-flex align-items-center w-100 h-100">
                      <i className="fas fa-flask flex-shrink-0"></i>
                      <div>
                        <span data-purecounter-start="0" data-purecounter-end="24" data-purecounter-duration="1" className="purecounter"></span>
                        <p>Info</p>
                      </div>
                    </div>
                  </div>

                </div>

              </div>
            </section>
          </>
        )}

        {tabIndex === 'matriculacion' && (
          <>
            {/* Matriculación Section */}
            <section id="matriculacion" className="about section">

              <div className="container section-title" data-aos="fade-up">
                <h2>Matriculación<br /></h2>
                <p>Lea atentamente los requisitos necesarios para incorporarse como un nuevo profesional en el Colegio de Fonoaudiólogos de La Pampa.</p>
              </div>

              <div className="container">
                <div className="row gy-4">
                  <div className="col-lg-6 position-relative align-self-start" data-aos="fade-up" data-aos-delay="100">
                    <img src="./assets/portal/img/sede/sede_1.jpg" className="img-fluid" alt="" /> <br /><br />
                    <img src="./assets/portal/img/sede/sede_5.jpg" className="img-fluid" alt="" /><br /><br />
                    <img src="./assets/portal/img/sede/sede_3.jpg" className="img-fluid" alt="" /><br /><br />
                    <img src="./assets/portal/img/sede/sede_4.jpg" className="img-fluid" alt="" /><br /><br />
                    <img src="./assets/portal/img/sede/sede_7.jpg" className="img-fluid" alt="" />
                  </div>
                  <div className="col-lg-6 content" data-aos="fade-up" data-aos-delay="200">
                    <p>
                      Deberá tenerse en cuenta que el profesional fonoaudiólogo que quiera ejercer la profesión en el ámbito asistencial, oficial o privado habilitado; en el ámbito educativo, oficial o privado; en el ámbito laboral, oficial o privado; en consultorios privados o en el domicilio del paciente; en establecimientos comerciales afines a su actividad específica, en el ámbito de la Provincia de La Pampa, deberá presentar su pedido de inscripción ante el Colegio de Fonoaudiólogos, para lo que deberá:
                    </p>
                    <ul>
                      <li><i className="bi bi-check2-all"></i> <span>Acreditar su identidad personal</span></li>
                      <li><i className="bi bi-check2-all"></i> <span>Presentar Título Habilitante (Diploma y certificado analítico) expedido por universidades nacionales, públicas o privadas, o institutos de enseñanza terciaria no universitaria, públicos o privados oficialmente reconocidos</span></li>
                      <li><i className="bi bi-check2-all"></i> <span>Declarar su Domicilio Real y el que constituirá con motivo del ejercicio profesional, que servirá a efectos de su relación con el Colegio</span></li>
                    </ul>
                    <p>
                      La matriculación en los términos antes expuestos, otorga al profesional el derecho a prestar servicios a todas las Obras Sociales con las cuales el Colegio suscriba Convenios de prestaciones.
                    </p>
                    <p className="fst-italic">
                      “Es requisito indispensable para el ejercicio de la profesión de Fonoaudiólogo en la Provincia, estar inscripto en la matrícula cuyo registro, atención y vigilancia son a cargo del Colegio.”(Capítulo II, art. 12, Ley Nº 2558).
                    </p>
                    <p>
                      Para tramitar la inscripción en la matrícula, se deberá presentar, sin excepción, TODA la documentación requerida, en el orden que aquí se establece y fotocopias en tamaño A4:
                    </p>
                    <ul>
                      <li><i className="bi bi-check2-all"></i> <span>Nota de Solicitud de Inscripción en la Matrícula (Según Formulario adjunto)</span></li>
                      <li><i className="bi bi-check2-all"></i> <span>Fotocopia de DNI con domicilio real (1º y 2º pág.), y cambio de domicilio si lo hubiese. En caso de no figurar el domicilio actualizado en el documento, presentar fotocopia comprobante Impuesto o Servicio para certificar el mismo. De no poseer, presentar Declaración Jurada realizada ante Policía</span></li>
                      <li><i className="bi bi-check2-all"></i> <span>TITULO ORIGINAL legalizado por Ministerio del Interior, por la Universidad o Ministeriode Educación pertinente, para ser sellado en el Acto de Matriculación con el número de matrícula que otorgue el Colegio Profesional de Fonoaudiólogos de La Pampa. El mismo será devuelto el mismo día de la matriculación</span></li>
                      <li><i className="bi bi-check2-all"></i> <span>Fotocopia de Título Profesional autenticado por Escribano Público</span></li>
                      <li><i className="bi bi-check2-all"></i> <span>4 fotos Carnet 4 x 4 color ACTUALIZADAS</span></li>
                      <li><i className="bi bi-check2-all"></i> <span>Copia comprobante de Depósito de Transferencia en concepto de Arancel de Matriculación. Datos Cuenta Bancaria: Cta. Cte. Nro. 100-01-441418/2 - CBU: 09303001 101000 44141828 - CUIT: 30-71151783/5</span></li>
                      <li><i className="bi bi-check2-all"></i> <span>Constancia de CBU expedida por el Banco de La Pampa, de Caja de Ahorro o Cuenta Corriente titularidad del profesional</span></li>
                    </ul>
                    <p>
                      El valor de la inscripción para el año 2025 asciende a $170000, y la Cuota Social mensual a $17000. Ambos valores se actualizan anualmente en Asamblea Ordinaria.
                    </p>
                    <p>
                      Para la adhesión al Débito Automático de la Cuota Mensual de Matriculación, es requisito indispensable contar con cuenta bancaria en el Banco de La Pampa SEM. Para tal fin, se debe adjuntar Planilla de Solicitud de Adhesión al DAS y constancia de CBU emitida por el Banco. La cuenta deberá ser la misma a la informada para el depósito de las liquidaciones mensuales.
                    </p>
                    <button className="btn-get-started" type="button">Descargar Solicitud</button> - <button className="btn-get-started" type="button">Descargar Das Adhesión</button>
                  </div>
                </div>
              </div>
            </section>
          </>
        )}
        
        {tabIndex === 'consultorio' && (
          <>
            {/* Consultorio Section */}
            <section id="consultorio" className="about section">
              <div className="container section-title" data-aos="fade-up">
                <h2>Requisitos para trabajar en Consultorio<br /></h2>
                <p>Toda documentación para iniciar trámites, se reciben de 1 al 15 de cada mes sin excepción, con cita previa. Pasado ese plazo, pasa al mes próximo.</p>
              </div>

              <div className="container">

                <div className="row gy-4">
                  <div className="col-lg-6 position-relative align-self-start" data-aos="fade-up" data-aos-delay="100">
                    <img src="./assets/portal/img/sede/sede_1.jpg" className="img-fluid" alt="" /> <br /><br />
                    <img src="./assets/portal/img/sede/sede_5.jpg" className="img-fluid" alt="" /><br /><br />
                    <img src="./assets/portal/img/sede/sede_3.jpg" className="img-fluid" alt="" />
                  </div>
                  <div className="col-lg-6 content" data-aos="fade-up" data-aos-delay="200">
                    <ul>
                      <li><i className="bi bi-check2-all"></i> <span>Constancia de Inscripción ante AFIP</span></li>
                      <li><i className="bi bi-check2-all"></i> <span>Constancia de Inscripción en el Impuesto a los Ingresos Brutos</span></li>
                      <li><i className="bi bi-check2-all"></i> <span>Habilitación de Consultorio expedido por el Ministerio de Salud de La Pampa, a nombre del matriculado</span></li>
                      <li><i className="bi bi-check2-all"></i> <span>Inscripción en Registro Nacional de Prestadores con el número de matrícula de COFOLP</span></li>
                      <li><i className="bi bi-check2-all"></i> <span>Certificado de Ética Profesional extendido por el Colegio (o por otro Colegio en caso de haber pertenecido o pertenecer)</span></li>
                      <li><i className="bi bi-check2-all"></i> <span>Constancia de seguro de mala praxis vigente</span></li>
                      <li><i className="bi bi-check2-all"></i> <span>Libre de deuda expedido por el Área Contable de el Colegio</span></li>
                      <li><i className="bi bi-check2-all"></i> <span>Declaración Jurada en donde el/la matriculado/a se compromete a informar cambio de situación fiscal</span></li>
                      <li><i className="bi bi-check2-all"></i> <span>Declaración Jurada de conformidad para ingresar al Listado de Prestador y trabajar con las Obras Sociales, mutuales o prepagas con las que el Colegio mantienen convenios</span></li>
                      <li><i className="bi bi-check2-all"></i> <span>Realizar capacitación de facturación por Obras Social a cargo de el Colegio</span></li>
                      <li><i className="bi bi-check2-all"></i> <span>Aceptación y conformidad de mantener la permanencia en el Listado de Prestadores que trabajan con Obras Sociales por un mínimo de 6 meses</span></li>
                      </ul>
                    <br /><br />
                    <button className="btn-get-started" type="button">Descargar Solicitud Inscripción Superintendencia</button><br /><br />
                    <button className="btn-get-started" type="button">Descargar Solicitud Registro Nacional de Prestadores</button>
                  </div>
                </div>

              </div>
            </section>
          </>
        )}
        
        {tabIndex === 'ejercicio-profesional' && (
          <>
            {/* Ejercicio Profesional Section */}
            <section id="ejercicioprofesional" className="services section">
              <div className="container section-title" data-aos="fade-up">
                <h2>Ejercicio Profesional</h2>
                <p>Aquí encontrará información sobre el ejercicio profesional.</p>
              </div>

              <div className="container">

                <div className="row gy-4">

                  <div className="col-lg-4 col-md-6" data-aos="fade-up" data-aos-delay="100">
                    <div className="service-item  position-relative">
                      <div className="icon">
                        <i className="fas fa-dollar"></i>
                      </div>
                      <a className="stretched-link" href='#'>Honorarios Mínimos Eticos</a>
                      <p>Descargue el archivo del año actual.</p>
                    </div>
                  </div>

                  <div className="col-lg-4 col-md-6" data-aos="fade-up" data-aos-delay="200">
                    <div className="service-item position-relative">
                      <div className="icon">
                        <i className="fas fa-certificate"></i>
                      </div>
                      <a className="stretched-link" href="#" >Código de Etica</a>
                      <p>Descargue el archivo del código de ética vigente.</p>
                    </div>
                  </div>

                  <div className="col-lg-4 col-md-6" data-aos="fade-up" data-aos-delay="300">
                    <div className="service-item position-relative">
                      <div className="icon">
                        <i className="fas fa-stamp"></i>
                      </div>
                      <a className="stretched-link" href="#" onClick={() => setTabIndex('certificado-etica')}>Certificado de Etica</a>
                      <p>Envíe una solicitud para obtener el certificado</p>
                    </div>
                  </div>

                  <div className="col-lg-4 col-md-6" data-aos="fade-up" data-aos-delay="400">
                    <div className="service-item position-relative">
                      <div className="icon">
                        <i className="fas fa-newspaper"></i>
                      </div>
                      <a className="stretched-link" href="#">Consentimiento Informado</a>
                      <p>Non et temporibus minus omnis sed dolor esse consequatur. Cupiditate sed error ea fuga sit provident adipisci neque.</p>
                    </div>
                  </div>

                  <div className="col-lg-4 col-md-6" data-aos="fade-up" data-aos-delay="500">
                    <div className="service-item position-relative">
                      <div className="icon">
                        <i className="fas fa-notes-medical"></i>
                      </div>
                      <a className="stretched-link" href="#" onClick={() => setTabIndex('consultorio')}>Habilitación del Consultorio</a>
                      <p>Revise la documentación necesaria para habilitar su consultorio.</p>
                    </div>
                  </div>

                  <div className="col-lg-4 col-md-6" data-aos="fade-up" data-aos-delay="600">
                    <div className="service-item position-relative">
                      <div className="icon">
                        <i className="fas fa-user"></i>
                      </div>
                      <a className="stretched-link" href="#" onClick={() => setTabIndex('matriculacion')}>Matriculación</a>
                      <p>Lea atentamente los requisitos para matricularse.</p>
                    </div>
                  </div>

                </div>

              </div>
            </section>
          </>
        )}
        
        {tabIndex === 'certificado-etica' && (
          <>
            {/* Appointment Section */}
            <section id="etica" className="appointment section light-background">
              <div className="container section-title" data-aos="fade-up">
                <h2>Solicitud de Certificado de Etica</h2>
                <p>Complete el siguiente formulario para realizar la solucitud al Colegio</p>
              </div>

              <div className="container" data-aos="fade-up" data-aos-delay="100">

                <form action="forms/appointment.php" method="post" className="php-email-form">
                  <div className="row">
                    <div className="col-md-4 form-group">
                      <input type="text" name="name" className="form-control" id="name" placeholder="Nombre Completo" required />
                    </div>
                    <div className="col-md-4 form-group mt-3 mt-md-0">
                      <select name="tipodoc" id="tipodoc" className="form-select" required >
                        <option value="">Tipo de Documento</option>
                        <option value="Department 1">DNI</option>
                        <option value="Department 2">LE</option>
                        <option value="Department 3">LC</option>
                      </select>
                    </div>
                    <div className="col-md-4 form-group mt-3 mt-md-0">
                      <input type="tel" className="form-control" name="numdoc" id="numdoc" placeholder="Número de Documento" required />
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-md-4 form-group">
                      <input type="text" name="nummatricula" className="form-control" id="nummatricula" placeholder="Número de Matrícula Profesional" required />
                    </div>
                    <div className="col-md-4 form-group">
                      <input type="text" onFocusCapture={(e) => (e.currentTarget.type = 'date')} name="fecmatriculacion" className="form-control datepicker" id="fecmatriculacion" placeholder="Fecha Matriculación" required />
                    </div>
                    <div className="col-md-4 form-group">
                      <input type="email" className="form-control" name="email" id="email" placeholder="Your Email" required />
                    </div>
                  </div>
                  <div className="mt-3">
                    <div className="loading">Loading</div>
                    <div className="error-message"></div>
                    <div className="sent-message">Your appointment request has been sent successfully. Thank you!</div>
                    <div className="text-center"><button type="submit">Enviar Solicitud</button></div>
                  </div>
                </form>

              </div>
            </section>
          </>
        )}

        {tabIndex === 'profesionales' && (
          <div className="profesionales">
            {/* Doctors Section - ahora tabla de profesionales */}
            <section id="profesionales" className="doctors section light-background">
              <div className="container section-title" data-aos="fade-up">
                <h2>Profesionales</h2>
                <p>Conozca a nuestros profesionales</p>
              </div>
              {/* Filtros: ahora debajo del título y arriba de la tabla */}
              <div className="container">
                <section className="filtros-profesionales mb-3">
                  <form className="row g-2 align-items-end">
                    <div className="col-md-3">
                      <label className="form-label mb-1">Nombre</label>
                      <input type="text" className="form-control" placeholder="Buscar por nombre" value={filtroNombre} onChange={e => setFiltroNombre(e.target.value)} />
                    </div>
                    <div className="col-md-3">
                      <label className="form-label mb-1">Localidad</label>
                      <select className="form-select" value={filtroLocalidad} onChange={e => setFiltroLocalidad(e.target.value)}>
                        <option value="">Todas</option>
                        {localidades.map(loc => (
                          <option key={loc} value={loc}>{loc}</option>
                        ))}
                      </select>
                    </div>
                    <div className="col-md-3">
                      <label className="form-label mb-1">Atiende Obra Social</label>
                      <select className="form-select" value={filtroObraSocial} onChange={e => setFiltroObraSocial(e.target.value)}>
                        <option value="">Todos</option>
                        <option value="si">Sí</option>
                        <option value="no">No</option>
                      </select>
                    </div>
                    <div className="col-md-3">
                      <label className="form-label mb-1">Especialidad</label>
                      <select className="form-select" value={filtroEspecialidad} onChange={e => setFiltroEspecialidad(e.target.value)}>
                        <option value="">Todas</option>
                        {especialidades.map(esp => (
                          <option key={esp} value={esp}>{esp}</option>
                        ))}
                      </select>
                    </div>
                  </form>
                </section>
                <div className="table-responsive">
                  <table className="table table-bordered align-middle text-center bg-white">
                    <thead className="table-light">
                      <tr>
                        <th>Nombre</th>
                        <th>Consultorio</th>
                        <th>Teléfono</th>
                        <th>Matrícula</th>
                        <th>CUIT</th>
                        <th>Especialidades</th>
                        <th>Atiende Obra Social</th>
                        <th>Redes</th>
                      </tr>
                    </thead>
                    <tbody className="t-body">
                      {profesionalesFiltrados.length === 0 && (
                        <tr><td colSpan={8}>No se encontraron profesionales.</td></tr>
                      )}
                      {profesionalesFiltrados.map((p, idx) => (
                        <tr key={p.nombre + idx}>
                          <td className="left-col">{p.nombre}</td>
                          <td>{p.consultorio}</td>
                          <td>{p.telefono}</td>
                          <td>{p.matricula}</td>
                          <td>{p.cuit}</td>
                          <td className="left-col">
                            {p.especialidades.map(esp => (
                              <div className="especialidad-tag" key={esp}>{esp}</div>
                            ))}
                          </td>
                          <td>
                            <span title="Atiende Obra Social">
                              {p.atiendeObraSocial ? (
                                <CheckIcon style={{ width: 24, height: 24, color: '#11c58c', verticalAlign: 'middle' }} aria-label="Sí" />
                              ) : (<></>
                                // <CloseIcon style={{ width: 24, height: 24, color: '#e74c3c', verticalAlign: 'middle' }} aria-label="No" />
                              )}
                            </span>
                          </td>
                          <td className="redes-icon">
                            {p.redes.twitter && (
                              <a href={p.redes.twitter} target="_blank" rel="noopener noreferrer"><i className="bi bi-twitter-x mx-1"></i></a>
                            )}
                            {p.redes.facebook && (
                              <a href={p.redes.facebook} target="_blank" rel="noopener noreferrer"><i className="bi bi-facebook mx-1"></i></a>
                            )}
                            {p.redes.instagram && (
                              <a href={p.redes.instagram} target="_blank" rel="noopener noreferrer"><i className="bi bi-instagram mx-1"></i></a>
                            )}
                            {p.redes.linkedin && (
                              <a href={p.redes.linkedin} target="_blank" rel="noopener noreferrer"><i className="bi bi-linkedin mx-1"></i></a>
                            )}
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </div>
            </section>
          </div>
        )}
        
        {tabIndex === 'tramites' && (
            <>
              {/* Faq Section */}
              <section id="tramites" className="faq section light-background">
                <div className="container section-title" data-aos="fade-up">
                  <h2>Trámites</h2>
                </div>

                <div className="container">

                  <div className="row justify-content-center">

                    <div className="col-lg-10" data-aos="fade-up" data-aos-delay="100">

                      <div className="faq-container">

                        <div className="faq-item">
                          <h3>Matriculación</h3>
                          <div className="faq-content">
                            <p>Deberá tenerse en cuenta que el profesional fonoaudiólogo que quiera ejercer la profesión en el ámbito asistencial, oficial o privado habilitado; en el ámbito educativo, oficial o privado; en el ámbito laboral, oficial o privado; en consultorios privados o en el domicilio del paciente; en establecimientos comerciales afines a su actividad específica, en el ámbito de la Provincia de La Pampa, deberá presentar su pedido de inscripción ante el Colegio de Fonoaudiólogos...<a href="#matriculacion" className="btn-get-started"> Consulte todos los requisitos</a>
                            </p>
                          </div>
                          <i className="faq-toggle bi bi-chevron-right"></i>
                        </div>

                        <div className="faq-item">
                          <h3>Consultorio</h3>
                          <div className="faq-content">
                            <p>Si usted va a trabajar en consultorio deberá presentar toda documentación para iniciar los siguientes trámites, se reciben de 1 al 15 de cada mes sin excepción, con cita previa. Pasado ese plazo, pasa al mes próximo.<a href="#consultorio" className="btn-get-started"> Ver documentación a presentar</a></p>
                          </div>
                          <i className="faq-toggle bi bi-chevron-right"></i>
                        </div>

                        <div className="faq-item">
                          <h3>Incorporación de Título</h3>
                          <div className="faq-content">
                            <p>Para el trámite incorporación de Título es necesario completar la nota de Solicitud de Incorporación de título y abonar el arancel equivalente a dos códigos 25.01.04<a href="#" className="btn-get-started" role="button" tabIndex={0} onClick={e => e.preventDefault()}> Descargar Solicitud Incorporación de Título</a></p>
                          </div>
                          <i className="faq-toggle bi bi-chevron-right"></i>
                        </div>

                        <div className="faq-item">
                          <h3>Requisitos para la baja de Matrícula</h3>
                          <div className="faq-content">
                            <p>Si usted desea dar de baja su matrícula deberá presentar toda documentación para iniciar el trámite.<a href="#" className="btn-get-started" role="button" tabIndex={0} onClick={e => e.preventDefault()}> Descargar Solicitud de Baja </a> - <a href="#" className="btn-get-started" role="button" tabIndex={0} onClick={e => e.preventDefault()}> Descargar Declaración Jurada</a></p>
                          </div>
                          <i className="faq-toggle bi bi-chevron-right"></i>
                        </div>

                      </div>

                    </div>

                  </div>

                </div>
              </section>
            </>
        )}

        {tabIndex === 'contacto' && (
          <>
            {/* Contact Section */}
            <section id="contact" className="contact section">
              <div className="container section-title" data-aos="fade-up">
                <h2>Contacto</h2>
              </div>

              <div className="mb-5" data-aos="fade-up" data-aos-delay="200">
                <iframe style={{ border: 0, width: "100%", height: "370px" }} src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3432.055793259047!2d-64.28344972377954!3d-36.60962886618601!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x95c2cda2ffebeb1b%3A0xfa949b07b5275bc8!2sAv.%20Agust%C3%ADn%20Spinetto%20670%2C%20L6300%20Santa%20Rosa%2C%20La%20Pampa!5e1!3m2!1ses-419!2sar!4v1761251729059!5m2!1ses-419!2sar" frameBorder="0" loading="lazy" referrerPolicy="no-referrer-when-downgrade"></iframe>
              </div>

              <div className="container" data-aos="fade-up" data-aos-delay="100">

                <div className="row gy-4">
                  <div className="col-lg-6 ">
                    <div className="row gy-4">

                      <div className="col-lg-12">
                        <div className="info-item d-flex flex-column justify-content-center align-items-center" data-aos="fade-up" data-aos-delay="200">
                          <i className="bi bi-geo-alt"></i>
                          <h3>Domicilio</h3>
                          <p>Avda. Spinetto 670 Dpto. 2 A, SANTA ROSA, La Pampa</p>
                        </div>
                      </div>

                      <div className="col-md-6">
                        <div className="info-item d-flex flex-column justify-content-center align-items-center" data-aos="fade-up" data-aos-delay="300">
                          <i className="bi bi-telephone"></i>
                          <h3>Teléfonos</h3>
                          <p>02954 - 702284 (Sede)</p>
                          <p>2954 - 295396 (Móvil)</p>
                        </div>
                      </div>

                      <div className="col-md-6">
                        <div className="info-item d-flex flex-column justify-content-center align-items-center" data-aos="fade-up" data-aos-delay="400">
                          <i className="bi bi-envelope"></i>
                          <h3>Email</h3>
                          <p>cofolp@gmail.com</p>
                          <p>asesoramiento-sei@googlegroups.com</p>
                        </div>
                      </div>

                    </div>
                  </div>

                  <div className="col-lg-6">
                    <form action="forms/contact.php" method="post" className="php-email-form" data-aos="fade-up" data-aos-delay="500">
                      <div className="row gy-4">

                        <div className="col-md-6">
                          <input type="text" name="name" className="form-control" placeholder="Nombre" required />
                        </div>

                        <div className="col-md-6 ">
                          <input type="email" className="form-control" name="email" placeholder="Email" required />
                        </div>

                        <div className="col-md-12">
                          <input type="text" className="form-control" name="subject" placeholder="Asunto" required />
                        </div>

                        <div className="col-md-12">
                          <textarea className="form-control" name="message" rows={4} placeholder="Consulta" required></textarea>
                        </div>

                        <div className="col-md-12 text-center">
                          <div className="loading">Cargando</div>
                          <div className="error-message"></div>
                          <div className="sent-message">Su mensaje ha sido enviado. Gracias!</div>

                          <button type="submit">Enviar Mensaje</button>
                        </div>

                      </div>
                    </form>
                  </div>

                </div>

              </div>
            </section>
          </>
        )}
      </main>
      {/* FOOTER */}
      <footer id="footer" className="footer light-background">
        <div className="container footer-top">
          <div className="row gy-4">
            <div className="col-lg-4 col-md-6 footer-about">
              <a href="index.html" className="logo d-flex align-items-center">
                <span className="sitename">Cofolp</span>
              </a>
              <div className="footer-contact pt-3">
                <p>Av. Spinetto 670</p>
                <p>Santa Rosa - La Pampa</p>
                <p className="mt-3"><strong>Teléfono:</strong> <span>+54 2954 702284</span></p>
                <p><strong>Email:</strong> <span>cofolp@gmail.com</span></p>
              </div>
              <div className="social-links d-flex mt-4">
                <a href="https://twitter.com" target="_blank" rel="noopener noreferrer"><i className="bi bi-twitter-x"></i></a>
                <a href="https://facebook.com" target="_blank" rel="noopener noreferrer"><i className="bi bi-facebook"></i></a>
                <a href="https://instagram.com" target="_blank" rel="noopener noreferrer"><i className="bi bi-instagram"></i></a>
                <a href="https://linkedin.com" target="_blank" rel="noopener noreferrer"><i className="bi bi-linkedin"></i></a>
              </div>
            </div>

            <div className="col-lg-2 col-md-3 footer-links">
              <h4>Links</h4>
              <ul>
                <li><a href="#" onClick={() => setTabIndex('home')}>Inicio</a></li>
                <li><a href="#" onClick={() => setTabIndex('institucional')}>Institucional</a></li>
                <li><a href="#" onClick={() => setTabIndex('tramites')}>Trámites</a></li>
                <li><a href="#" onClick={() => setTabIndex('ejercicio-profesional')}>Ejercicio Profesional</a></li>
                <li><a href="#" onClick={() => setTabIndex('profesionales')}>Profesionales</a></li>
              </ul>
            </div>

            <div className="col-lg-2 col-md-3 footer-links">
              <h4>Ejercicio Profesional</h4>
              <ul>
                <li><a href='#'>Honorarios Mínimos</a></li>
                <li><a href='#'>Código de Etica</a></li>
                <li><a href='#' onClick={() => setTabIndex('certificado-etica')}>Certificado de Etica</a></li>
                <li><a href='#'>Consentimiento Informado</a></li>
              </ul>
            </div>

            <div className="col-lg-2 col-md-3 footer-links">
              <h4>Trámites</h4>
              <ul>
                <li><a href="#" onClick={() => setTabIndex('matriculacion')}>Matriculación</a></li>
                <li><a href="#" onClick={() => setTabIndex('consultorio')}>Consultorio</a></li>
                <li><a href="#">Título</a></li>
                <li><a href="#">Baja de Matrícula</a></li>
              </ul>
            </div>

            

          </div>
        </div>

        <div className="container copyright text-center mt-4">
          <p>© <span>Copyright</span> <strong className="px-1 sitename">Cofolp</strong> <span>Todos los derechos reservados</span></p>
          <div className="credits">
          </div>
        </div>
      </footer>
      {/* Scroll Top */}
      <a id="scroll-top" className="scroll-top d-flex align-items-center justify-content-center" ><i className="bi bi-arrow-up-short"></i></a>
      {/* Preloader */}
      {/* <div id="preloader"></div> */}
    </>
  );
};

export default PortalHome;
